import { useEffect, useState } from 'react';
import { AnalyticsConsent, CONSENT_CHANGE_EVENT, getAnalyticsConsent, setAnalyticsConsent } from '../utils/analytics';

/** The visitor's analytics choice, kept in sync between the banner and the settings page. */
export const useAnalyticsConsent = (): [AnalyticsConsent | null, (choice: AnalyticsConsent) => void] => {
  const [consent, setConsent] = useState<AnalyticsConsent | null>(getAnalyticsConsent);

  useEffect(() => {
    const sync = () => setConsent(getAnalyticsConsent());
    window.addEventListener(CONSENT_CHANGE_EVENT, sync);
    // Another tab made the choice
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(CONSENT_CHANGE_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  return [consent, setAnalyticsConsent];
};
